"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var BrandingSdk = require('@nackle/branding-sdk');
var _require = require('../utils/endpoints'),
  brandingUrl = _require.brandingUrl;
module.exports = function (_ref) {
  var fetch = _ref.fetch;
  var sdk = BrandingSdk(brandingUrl, fetch);
  return {
    getLogosAndColors: function getLogosAndColors() {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var options, _await$sdk$getStyles, styles, primaryColorStyle, secondaryColorStyle, primaryLogoStyle, secondaryLogoStyle;
        options = $args.length > 0 && $args[0] !== undefined ? $args[0] : {};
        return Promise.resolve(sdk.getStyles(_objectSpread(_objectSpread({}, options), {}, {
          elementName: ['color', 'logo']
        }))).then(function ($await_1) {
          try {
            _await$sdk$getStyles = $await_1, styles = _await$sdk$getStyles.styles;
            primaryColorStyle = styles.find(function (s) {
              return s.propertyName == 'primary';
            });
            secondaryColorStyle = styles.find(function (s) {
              return s.propertyName == 'secondary';
            });
            primaryLogoStyle = styles.find(function (s) {
              return s.intent === 'PRIMARY';
            });
            secondaryLogoStyle = styles.find(function (s) {
              return s.intent === 'SECONDARY';
            });
            return $return({
              primaryColor: primaryColorStyle ? primaryColorStyle.value : null,
              secondaryColor: secondaryColorStyle ? secondaryColorStyle.value : null,
              primaryLogo: primaryLogoStyle ? primaryLogoStyle.value : null,
              secondaryLogo: secondaryLogoStyle ? secondaryLogoStyle.value : null
            });
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    }
  };
};
//# sourceMappingURL=branding.js.map